import { Box, CircularProgress, Modal, Stack, Typography } from "@mui/material";
import MDBadge from "components/MDBadge";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLabel } from "../../../../redux/labels";
import { getBadge } from "../../../../redux/badge";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  maxHeight: "80%",
  bgcolor: "background.paper",
  borderRadius: "10px",
  overflow: "auto",
  boxShadow: 24,
  p: 4,
};

function ModalGroup({ active, onClose, dataIndex, ...rest }) {
  const groups = useSelector((state) => state.group.list);
  const labels = useSelector((state) => state.label.list);
  const badges = useSelector((state) => state.badge.list);
  const shopDomain = useSelector((state) => state.shop.shopDomain);
  const [group, setGroup] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    setGroup(groups[dataIndex]);
  }, [dataIndex, groups]);

  useEffect(() => {
    if (shopDomain) {
      dispatch(getLabel(shopDomain));
      dispatch(getBadge(shopDomain));
    }
  }, [shopDomain]);

  useEffect(() => {
    setLoading(false);
  }, [group]);

  const flexDirection = {
    "pl-flex-column": "Column",
    "pl-flex-row": "Row",
  };
  const disablePositions = [
    "group_before_title",
    "group_after_title",
    "group_before_price",
    "group_after_price",
  ];

  return (
    <Modal open={active} onClose={onClose}>
      <Box sx={style}>
        {loading ? (
          <Box>
            <CircularProgress color="info" />
          </Box>
        ) : (
          <>
            <Typography>
              {`${group?.type == "label" ? "Label" : "Badge"}: ${group?.name}`}{" "}
            </Typography>
            <Box sx={{ marginTop: 2 }}>
              <Stack spacing={2}>
                <Stack direction="row" spacing={1}>
                  <Typography variant="body2"> Position:</Typography>
                  <Typography variant="body2" color="tomato">
                    {group?.position}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                  <Typography variant="body2"> Position type:</Typography>
                  <Typography variant="body2" color="tomato">
                    {group?.position_unit_type}
                  </Typography>
                </Stack>
                {group?.label_ids?.map((id, index) => {
                  const item = labels?.find((label) => label.id === id);
                  return (
                    item && (
                      <Stack direction="row" spacing={1} key={index}>
                        <Typography variant="body2"> Label {item.id}:</Typography>
                        <div
                          style={{
                            width: "100px",
                            height: "30px",
                            display: "flex",
                            alignContent: "center",
                          }}
                        >
                          <img src={item?.image} width="auto" height={30} />
                          {item?.label_type === 1 && (
                            <div
                              className={`${
                                item?.label_type === 1 && !item.image ? item.design.shape_class : ""
                              }`}
                              style={{
                                width: "30px",
                                height: "100%",
                                backgroundColor: !item.image && item.design.shape_color,
                              }}
                            ></div>
                          )}
                        </div>
                        <Stack direction="row" spacing={2} alignItems="center">
                          {item?.label_type === 1 && (
                            <Typography variant="caption">{item?.text}</Typography>
                          )}
                        </Stack>
                      </Stack>
                    )
                  );
                })}
                {group?.badge_ids?.map((id, index) => {
                  const item = badges?.find((badge) => badge.id === id);
                  return (
                    item && (
                      <Stack direction="row" spacing={1} key={index}>
                        <Typography variant="body2"> Badge {item.id}:</Typography>
                        <div
                          style={{
                            width: "100px",
                            height: "30px",
                            display: "flex",
                            alignContent: "center",
                          }}
                        >
                          <img src={item?.image} width="auto" height={30} />
                          {item?.badge_type === 1 && (
                            <div
                              className={`${
                                item?.badge_type === 1 && !item.image ? item.design.shape_class : ""
                              }`}
                              style={{
                                width: "30px",
                                height: "100%",
                                backgroundColor: !item.image && item.design.shape_color,
                              }}
                            ></div>
                          )}
                        </div>
                        <Stack direction="row" spacing={2} alignItems="center">
                          {item?.badge_type === 1 && (
                            <Typography variant="caption">{item?.text}</Typography>
                          )}
                        </Stack>
                      </Stack>
                    )
                  );
                })}

                {group?.type === "badge" &&
                  group?.predefined_position &&
                  !disablePositions.includes(group?.position) && (
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body2">Predefined position:</Typography>
                      <Typography variant="body2" color="tomato">
                        {group?.predefined_position}
                      </Typography>
                    </Stack>
                  )}
                <Stack direction="row" spacing={1}>
                  <Typography variant="body2"> Direction:</Typography>
                  <Typography variant="body2" color="tomato">
                    {flexDirection[group?.flex_direction]}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                  <Typography variant="body2"> Gap between {group?.type}s:</Typography>
                  <Typography variant="body2" color="tomato">
                    {group?.gap} px
                  </Typography>
                </Stack>
                {group?.type === "label" && (
                  <>
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body2">
                        Spacing {group?.position.split("_")[1]}:
                      </Typography>
                      <Typography variant="body2" color="tomato">
                        {group?.vertical} {group?.position_unit_type === "fixed" ? "px" : "%"}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body2">
                        Spacing {group?.position.split("_")[2]}:
                      </Typography>
                      <Typography variant="body2" color="tomato">
                        {group?.horizontal} {group?.position_unit_type === "fixed" ? "px" : "%"}
                      </Typography>
                    </Stack>
                  </>
                )}
                {group?.type === "badge" && group?.margin && (
                  <>
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body2">Spacing top:</Typography>
                      <Typography variant="body2" color="tomato">
                        {group?.margin?.top} {group?.position_unit_type === "fixed" ? "px" : "%"}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body2">Spacing bottom:</Typography>
                      <Typography variant="body2" color="tomato">
                        {group?.margin?.bottom} {group?.position_unit_type === "fixed" ? "px" : "%"}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body2">Spacing left:</Typography>
                      <Typography variant="body2" color="tomato">
                        {group?.margin?.left} {group?.position_unit_type === "fixed" ? "px" : "%"}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body2">Spacing right:</Typography>
                      <Typography variant="body2" color="tomato">
                        {group?.margin?.right} {group?.position_unit_type === "fixed" ? "px" : "%"}
                      </Typography>
                    </Stack>
                  </>
                )}
              </Stack>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}

ModalGroup.defaultProps = {
  active: true,
  onClose: () => {},
  dataIndex: 0,
};

ModalGroup.propTypes = {
  active: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  dataIndex: PropTypes.number,
};

export default ModalGroup;
